<app-breadcrumb></app-breadcrumb>

<div class="table-container">

  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div class="form-template">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container" style="padding-bottom: 5px;">
          <span class="gridName">Feedback Template</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- Template Name -->
        <div><label for="email">Template Name</label><span class="mandatory-symbol">*</span></div>
        <input id="templateName" class="input-filed-continers" type="text"
          [(ngModel)]="feedbackTemplateData.templateName">
        <span id="templateName-required-msg">Please enter the template Name</span>
      </div>
      <div class="col-md-4">
        <div><label for="email ">Score Formula</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="feedbackTemplateData.scoreFormula">
      </div>

      <div class="col-md-2">
        <div><label for="isMand">Is Active?</label></div>
        <mat-slide-toggle color="primary" [(ngModel)]="feedbackTemplateData.isActive1">
          <span class="active-inActive-container" *ngIf="feedbackTemplateData.isActive1==true"
            [ngStyle]="feedbackTemplateData.isActive1 == true?{'color':'green'} : {'color': ''}">Yes</span>
          <span *ngIf="feedbackTemplateData.isActive1==false"
            [ngStyle]="feedbackTemplateData.isActive1 == false?{'color':'red'} : {'color': ''}">No</span>
        </mat-slide-toggle>
      </div>

    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- Template Description -->
        <div><label for="email">Template Description</label></div>
        <textarea class="textarea-filed-continers" style="height: 120px;" type="text"
          [(ngModel)]="feedbackTemplateData.templateDescription"></textarea>
      </div>
      <div class="col-md-6">
        <!-- Template Name -->
        <div><label for="email " id="update-validation">Update Reason</label><span class="mandatory-symbol">*</span>
        </div>
        <textarea id="update" class="textarea-filed-continers" style="height: 120px;" type="text"
          [(ngModel)]="feedbackTemplateData.updateReason"></textarea>
        <span id="update-required-msg">Please enter update reason</span>
      </div>
    </div>

    <br><br>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="updateFeedbackTemplate()">
        <i class="fas fa-user-edit"></i> Update
      </button>
      <button mat-stroked-button class="cancelButton" style="margin-left: 1%;" (click)="backToFormTemplate()">
        Cancel
      </button>
    </div>
  </div>
</div>
<br>
<div class="form-template">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container" style="padding-bottom: 5px;">
        <span class="gridName">Template Questions</span>
      </div>
    </div>
  </div>
  <div class="position-relative grid-content">
    <div>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center px-3">
          <div class="dropdown">
          </div>
        </div>
        <div class="d-flex gap-3">
          <div id="header-container">
            <div class="">
              <div class="search-container">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="text" class="form-control search_input" style="font-size: 12px"
                  placeholder="Search here..." [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
              </div>
            </div>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (keydown.enter)="openAddPopup()" (click)="openAddPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add Template Questions</span>
          </div>

          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reload</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="callReorderFunc()" (keydown.enter)="callReorderFunc()" matTooltip="Reorder Question">
            <img src="../../../assets/img/training_module/Order.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reorder</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <table class="dynamic-table-container">
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th class="grid-header-container" *ngFor="let feedbackTemplateData of columnList; let ix = index;" [ngStyle]="{
                      'min-width': feedbackTemplateData.width,
                      'max-width': feedbackTemplateData.width,
                      'overflow': 'hidden',
                      'text-overflow': 'ellipsis',
                      'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)"
          (focus)="focusEmpty()">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{ feedbackTemplateData.column }}</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn(columnList[ix],feedbackTemplateData)"
                (keydown.enter)="sortColumn(columnList[ix],feedbackTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div>
            </div>
          </div>
        </th>
        <th  class="sticky-col first-col"></th>
        <tr>
          <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
          <td *ngFor=" let oneQmsUsersDataForTable1Data of columnList; let ix = index "
            [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
            class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
            <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3(columnList[ix], $event)" /> </div>
          </td>
        </tr>
        <tr *ngFor="let list of pagedItems let idx = index;" [class.highlightRow]="list.childCheckBoxs == true">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{list.questionSeq}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{list.questionCode}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{list.question}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{list.fieldTypeCode}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
               white-space: 'nowrap'"><span>{{list.fieldLovValues}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"><span>{{list.fieldValueScores}}</span></td>

          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'"><span>{{list.createdOn | date:uiDateTimeFormat | uppercase}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'"><span>{{list.createdByUser}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                 white-space: 'nowrap'"><span>{{list.updatedOn | date:uiDateTimeFormat | uppercase}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                 white-space: 'nowrap'"><span>{{list.updatedByUser}}</span></td>
          <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                 white-space: 'nowrap'"><span>{{list.updateReason}}</span></td>
          <td class="sticky-col first-col">
            <div class="action-icons">
              <i class="fa-sharp fa-solid fa-edit" matTooltip="Edit Feedback Template Question"
                style="margin-left: 5px;" (click)="openEditPopup(list)" (keydown.enter)="openEditPopup(list)"></i>
              <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete Feedback Template Question"
                style="margin-left: 5px;" (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)"></i>
            </div>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #addOrEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
      <div class="row">
        <div class="col-md-4">
          <div><label for="email ">Question Code</label><span class="mandatory-symbol">*</span></div>
          <input id="questionCode" class="input-filed-continers" type="text"
            [(ngModel)]="feedbackTemplateQuestionData.questionCode">
          <span id="questionCode-required-msg">Please enter question code</span>
        </div>
        <div class="col-md-8">
          <div><label for="email">Question</label><span class="mandatory-symbol">*</span></div>
          <textarea id="question" class="textarea-filed-continers" type="text"
            [(ngModel)]="feedbackTemplateQuestionData.question"></textarea>
          <span id="question-required-msg">Please enter question</span>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">Field Type</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" id="fieldType"
            [(ngModel)]="feedbackTemplateQuestionData.fieldTypeCode" (closed)="fieldTypesearchTxt=''"
            (click)="focusmethod('fieldTypefocusSearch')" (keydown.enter)="focusmethod('fieldTypefocusSearch')">
            <input type="search" id="fieldTypefocusSearch" class="dropdownsearchstyle" [(ngModel)]="fieldTypesearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of fieldTypeListDropdown | assessmentSearch :fieldTypesearchTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="fieldType-required-msg">Please select the Field Type</span>
        </div>
        <div class="col-md-4">
          <div><label for="email">LOV Values</label></div>
          <textarea class="textarea-filed-continers" type="text"
            [(ngModel)]="feedbackTemplateQuestionData.fieldLovValues"></textarea>
        </div>
        <div class="col-md-4">
          <div><label for="email">Value Scores</label></div>
          <textarea class="textarea-filed-continers" type="text"
            [(ngModel)]="feedbackTemplateQuestionData.fieldValueScores"></textarea>
        </div>
        <div class="col-md-4" *ngIf="visibleEditButton">
          <!-- Template Name -->
          <div><label for="email " id="update-req-validation">Update Reason</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="update-req" rows="4" class="textarea-filed-continers" type="text"
            [(ngModel)]="feedbackTemplateQuestionData.updateReason"></textarea>
          <span id="update-req-msg">Please enter update reason</span>
        </div>
      </div>
      <br>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(feedbackTemplateQuestionData)" (keydown.enter)="addAndEditFunction(feedbackTemplateQuestionData)" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(feedbackTemplateQuestionData)" (keydown.enter)="addAndEditFunction(feedbackTemplateQuestionData)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row" style="width: 100%;">
      <div class="col-md-12">
        <div><label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span></div>
        <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
          [(ngModel)]="feedbackTemplateQuestionData.deleteReason"></textarea>
        <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="deleteFunction()" (keydown.enter)="deleteFunction()">
        <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Delete</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #reorderQuestionPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReorderFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{title}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <b>Drag and drop to reorder the question sequence</b>
    <div class="table-container">
      <table class="dynamic-table-container">
        <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Content Seq</span> <span class="grid-header-container"></span> </th>
        <th style="width: 240px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Name</span> <span class="grid-header-container"></span> </th>
        <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>New Seq</span> <span class="grid-header-container"></span> </th>

        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle
            *ngFor="let question of feedbackTemplateQuestionList let idx = index;">
            <td class="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{question.questionSeq}}</span></td>
            <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{question.question}}</span></td>
            <td class="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{question.newSeq}}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="reorderQuestionFunction()">
        <i class="fa fa-redorder"></i> Reorder
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>